var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChain20 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.517 2.176a2.357 2.357 0 0 1 3.303 0 2.273 2.273 0 0 1 0 3.242l-.687.679a.75.75 0 0 0 1.055 1.066l.687-.678a3.772 3.772 0 0 0 0-5.376 3.857 3.857 0 0 0-5.413 0L6.125 4.408a3.772 3.772 0 0 0 0 5.375.75.75 0 1 0 1.055-1.066 2.272 2.272 0 0 1 0-3.242l3.337-3.3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.483 13.824c-.91.901-2.392.901-3.303 0a2.272 2.272 0 0 1 0-3.242l.687-.679a.75.75 0 1 0-1.055-1.066l-.687.678a3.772 3.772 0 0 0 0 5.376 3.857 3.857 0 0 0 5.413 0l3.337-3.299a3.772 3.772 0 0 0 0-5.375.75.75 0 0 0-1.055 1.066 2.272 2.272 0 0 1 0 3.242l-3.337 3.3Z",
    fill: "currentColor"
  })));
};
export default SvgChain20;